module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-down-1.de1f7e7b.svg";